import { render, staticRenderFns } from "./RecentDeposits.vue?vue&type=template&id=80a2703a&scoped=true&"
import script from "./RecentDeposits.vue?vue&type=script&lang=js&"
export * from "./RecentDeposits.vue?vue&type=script&lang=js&"
import style0 from "./RecentDeposits.vue?vue&type=style&index=0&id=80a2703a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a2703a",
  null
  
)

export default component.exports